import React from 'react'
import PropTypes from 'prop-types'
import Text from './Text'

const CLASSES = 'tw:text-inherit! tw:underline! tw:decoration-solid'

const buildRel = (target, rel) => {
  if (rel)
    return rel
  if (target === '_blank')
    return 'noopener noreferrer'
  return null
}

const Link = ({
  children, className = '', href, rel = null, target = null,
  lines = null, truncate = false, ...rest
}) => {
  const anchor = (
    <a
      className={`${CLASSES} ${className}`.trim()}
      href={href}
      rel={buildRel(target, rel)}
      target={target}
      {...rest}
    >
      {children}
    </a>
  )
  if (lines || truncate)
    return <Text lines={lines} truncate={truncate}>{anchor}</Text>
  return anchor
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  lines: PropTypes.oneOf([1, 2, 3]),
  rel: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  truncate: PropTypes.bool
}

Link.defaultProps = {
  className: '',
  lines: null,
  rel: null,
  target: null,
  truncate: false
}

export default Link
